import { Instance } from 'mobx-state-tree';
import { RouteUnpublishedDtoModelBase } from './RouteUnpublishedDtoModel.base';

/* The TypeScript type of an instance of RouteUnpublishedDtoModel */
export interface RouteUnpublishedDtoModelType extends Instance<typeof RouteUnpublishedDtoModel.Type> {}

/* A graphql query fragment builders for RouteUnpublishedDtoModel */
export { selectFromRouteUnpublishedDto, routeUnpublishedDtoModelPrimitives, RouteUnpublishedDtoModelSelector } from './RouteUnpublishedDtoModel.base';

/**
 * RouteUnpublishedDtoModel
 *
 * Route unpublished event
 */
export const RouteUnpublishedDtoModel = RouteUnpublishedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
